import { newTracker } from '@snowplow/browser-tracker'
import { EnhancedConsentPlugin } from '@snowplow/browser-plugin-enhanced-consent'

type InitSnowplowTrackerParams = {
  collectorUrl: string
  appId: string
  namespace: string
  postPath?: string
}

/**
 * @see https://docs.snowplow.io/docs/sources/trackers/web-trackers/quick-start-guide/
 */
export const initSnowplowTracker = ({
  collectorUrl,
  appId,
  namespace,
  postPath,
}: InitSnowplowTrackerParams) => {
  // https://docs.snowplow.io/docs/sources/web-trackers/tracker-setup/initialization-options/
  newTracker(namespace, collectorUrl, {
    appId,
    discoverRootDomain: true,
    plugins: [EnhancedConsentPlugin()],
    postPath,
  })
}
